import * as React from "react";
import AnnonceContext from "../../../../../contexts/AnnonceContext";

export default function DaySelector() {
  const { formAnnonce, setFormAnnonce, setDate } = React.useContext(
    AnnonceContext
  );

  const [selectedDay, setSelectedDay] = React.useState(0);
  const day = new Date();

  const handleChange = (value) => {
    const newDay = new Date();
    newDay.setDate(newDay.getDate() - value);
    setSelectedDay(value);
    setDate(newDay);
    setFormAnnonce({ ...formAnnonce, date: newDay.toISOString() });
  };

  const days = [
    { value: 0, label: "Aujourd'hui" },
    { value: 1, label: "Hier" },
    { value: 2, label: "Avant-hier" },
    { value: 3, label: "Il y a 3 jours" },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {days.map((day) => (
        <button
          key={day.value}
          onClick={() => handleChange(day.value)}
          className={`px-4 py-2 rounded-md transition-colors ${
            selectedDay === day.value
              ? 'bg-[#1b9faa] text-white'
              : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
          }`}
        >
          {day.label}
        </button>
      ))}
    </div>
  );
}
